export default __webpack_public_path__ + "static/media/bc055cbef804633f.ddc2a4373e0291e837793d60c755b5f2.svg";